import { Platform } from 'react-native';

export const logEvent = ({ name }) => {
  if (Platform.OS === 'web' && window.dataLayer) {
    if (process.env.NODE_ENV === 'development') {
      console.log('dataLayer send', { event: name });
    } else {
      window.dataLayer.push({
        event: name,
      });
    }
  }
};
